import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ServiceTextSmallImage = ({ blok }) => (
  <div className="wrap">
  <div className="textsmallimage-wrap inner-wrap" {...storyblokEditable(blok)}>
    <div className="textsmallimage-text">
          <h2 className="text-2xl merriweather">{blok.subheadline}</h2>
          <div className="hide-mobile textsmallimage-smallimage">
            {blok.linknewtab && (<Link target="_blank" href={blok.linknewtab} ><img src={blok.imagenewtab.filename} alt={blok.imagenewtab.alt} /></Link>)}
            {blok.link && (<Link href={blok.link} ><img src={blok.image.filename} alt={blok.image.alt} /></Link>)}
          </div>
          
    <p>{blok.infotext}</p> 
    </div>
    <div className="textsmallimage-image">
        <div className="hide-desktop">
            {blok.link && (<Link href={blok.link} ><img src={blok.image.filename} alt={blok.image.alt} /></Link>)}
            {blok.linknewtab && (<Link target="_blank" href={blok.linknewtab} ><img src={blok.imagenewtab.filename} alt={blok.imagenewtab.alt} /></Link>)}
        </div>
        
    </div>
  </div>
  </div>
);

export default ServiceTextSmallImage;
